// App.js
import React from 'react';
import '../App.css';
import CustomVideoPlayer from '../remotion/players/RecruitingVideoPlayer';  //add this back later
import jacob_pic from '../assets/Jacob_Square_Pic.jpg';
import VimeoVideoEmbed from './youtubeVideoEmbed';



const data = {              
  photo: jacob_pic,
  text: "Instead of a salary, I make my money the exact same way as everybody else.",
  name: "Jacob Chapman",
  title: "CEO, Desert North Realty",
}


const VideoAndQuote = () =>  {
  const { photo, text, name, title } = data;
  return (

  <div className='center' style={{backgroundColor:'white', padding:'1em 0'}}>
    <div className='flex' style={{width:'80%', backgroundColor:'transparent'}}>
      
        <div className='center'>
        <div style={{ backgroundColor: "transparent",  width: '100%' }}>
          <div class="flex-container" 
              style={{ 
                flexDirection:'row',
                justifyContent: 'center',
                  alignItems: 'center',
                

        
        
                    }}>

            <div className="flex-box-70">
              <div style={{ 
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '0',
                  backgroundColor: 'transparent',
                  }}>
                    <CustomVideoPlayer />

              </div>
            
            
            </div>
            <div className="flex-box-30 center">
            <div  style={{ backgroundColor:'transparent'}}>

                <div className="featured center" style={{ backgroundColor:'#BCD400', transform:'scale(.7)'}}> 
                  <div className="testimonial-content" style={{ justifyContent: 'center' }}>
                      <p className="auto-scale-text-xs" style={{ color: 'white' }}>"{text}"</p>
                    </div>
                      <div className="testimonial-image-wrapper">
                      <img src={photo} alt={`${name} Profile`} className="testimonial-image" />
                    </div>
                    <div className="testimonial-content">
                      <div className="auto-scale-text-xs">{name}</div>
                      <div className="auto-scale-text-xs" style={{ color:'white'}}>{title}</div>
                    </div>
                  </div>
                </div>
                </div>

        </div>
        </div>
        </div>
    
    

    
    
    </div>



      <div>
       
      </div>
      
    </div>

  );
}

export default VideoAndQuote;